import { Match } from "effect";

export type BrowserArch = "chromium" | "firefox" | "safari";
export type BrowserName = "chrome" | "edge" | "opera" | "brave" | "firefox" | "safari";

export const getBrowserName = () => {
	const browser = navigator.userAgent.toLowerCase();
	return Match.value(browser).pipe(
		Match.withReturnType<BrowserName>(),
		Match.when(
			(b) => b.includes("edge"),
			() => "edge",
		),
		Match.when(
			(b) => b.includes("opera"),
			() => "opera",
		),
		Match.when(
			(b) => b.includes("brave"),
			() => "brave",
		),
		Match.when(
			(b) => b.includes("chrome"),
			() => "chrome",
		),
		Match.when(
			(b) => b.includes("firefox"),
			() => "firefox",
		),
		Match.when(
			(b) => b.includes("safari"),
			() => "safari",
		),
		Match.orElse(() => {
			console.warn(`Could not detect browser name, defaulting to chrome`);
			return "chrome";
		}),
	);
};

export const getBrowserArch = () => {
	const browserName = getBrowserName();
	return Match.value(browserName).pipe(
		Match.withReturnType<BrowserArch>(),
		Match.whenOr("chrome", "edge", "opera", "brave", () => "chromium"),
		Match.when("firefox", () => "firefox"),
		Match.when("safari", () => "safari"),
		Match.orElse(() => {
			console.warn(`Could not detect browser architecture, defaulting to chromium`);
			return "chromium";
		}),
	);
};
